module.exports = __webpack_public_path__ + "static/media/init-actions-upgrade.83ebad07.png";